import { render } from "./SectionAccountSetting.vue?vue&type=template&id=694b1c12&scoped=true"
import script from "./SectionAccountSetting.vue?vue&type=script&lang=js"
export * from "./SectionAccountSetting.vue?vue&type=script&lang=js"

import "./SectionAccountSetting.vue?vue&type=style&index=0&id=694b1c12&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694b1c12"]])

export default __exports__